module.exports = __webpack_public_path__ + "static/media/UnPin.cb9b8989.svg";